<app-field-renderer
  [form]="form"
  [roles]="roleColors"
  [isRoleEditable]="isRoleEditable"
  [boundsRef]="boundsRef"
  [inBounds]="inBounds"
  [offsetRect]="offsetRect"
  [zoomScale]="zoomScale"
  [disableCustomFont]="disableCustomFont"
  [role2ColorMapping]="role2ColorMapping"
  (afterMove)="onMove()"
  (afterResize)="onResize()"
  (remove)="onRemove($event)"
  (roleChange)="onRoleChange($event)"
>
  <ng-container class="title">
    <i class="fas fa-signature mr-2"></i> <ng-container i18n>Signature</ng-container>
  </ng-container>
  <ng-container class="label">
    <i class="cs-icon cs-icon-sign"></i>
    <span *ngIf="role">{{ role }}</span> {{ label || defaultLabel }}
  </ng-container>
</app-field-renderer>
